// extracted by mini-css-extract-plugin
export var currencyInput = "_ku-1";
export var currencySymbol = "_ku-0";